import { CompanyUsersStateKey } from '../app-entities/app-entities-keys';
import { AppGlobalStateKey, SessionStateKey } from '../app-global/app-global-keys';

/**
 * The state to feed the root reducer on sign-out, so that every slice re-initialises itself.
 */
export function retainedStateForReset(state: any): Record<string, any> | undefined {
  // `SessionStateKey` is the one key carried across, and the only exception.
  const session = state?.[AppGlobalStateKey]?.[SessionStateKey];
  if (session === undefined) return undefined;

  return { [AppGlobalStateKey]: { [SessionStateKey]: session } };
}

export function clearCompanySpecificState(newState: any) {
  const retainKeys = ['router', AppGlobalStateKey, CompanyUsersStateKey];

  Object.keys(newState)
    .filter(key => !retainKeys.includes(key))
    .forEach(key => {
      Object.keys(newState[key]).forEach(subKey => {
        if (!retainKeys.includes(subKey)) {
          newState[key][subKey] = undefined;
        }
      });
    });

  return newState;
}
